import { MessageCircle } from "lucide-react";

const WHATSAPP_NUMBER = "919974993396"; // 5GB Corporation WhatsApp business line
const WHATSAPP_MSG = encodeURIComponent(
  "Hi 5GB Corporation, I want to know more about the home business program."
);

export const WhatsAppFAB = () => {
  return (
    <a
      href={`https://wa.me/${WHATSAPP_NUMBER}?text=${WHATSAPP_MSG}`}
      target="_blank"
      rel="noopener noreferrer"
      data-testid="whatsapp-fab"
      className="fixed bottom-6 right-6 z-50 h-16 w-16 rounded-full bg-[#25D366] shadow-xl flex items-center justify-center hover:scale-110 transition-transform"
      aria-label="Chat on WhatsApp"
    >
      <MessageCircle className="h-8 w-8 text-white" fill="white" />
      <span className="absolute -top-1 -right-1 h-4 w-4 rounded-full bg-[#C2410C] border-2 border-white animate-pulse" />
    </a>
  );
};

export default WhatsAppFAB;
